//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomDialog from '@/components/CustomDialog.vue';
export default {
    components: { CustomDialog },
    props: {
        zIndex: {
            type: [String, Number],
            defalut: 1
        }
    },
    data() {
        return {
            vrData: '',
            show: {
                vr: false
            }
        };
    },
    mounted() {
        this.getVr();
    },
    methods: {
        getVr() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: 60
                }
            }).then(res => {
                if (res.code === 0) {
                    this.vrData = res.data;
                }
            });
        }
    }
};
